import {Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface AssetTrustProgressSummaryProps {
  purchasePriceFormatted: string;
  depositPaidFormatted: string;
  /** 0–100 */
  percent: number;
}

export const AssetTrustProgressSummary: FC<AssetTrustProgressSummaryProps> = ({
  purchasePriceFormatted,
  depositPaidFormatted,
  percent
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <div className="flex items-baseline gap-4">
      <div className="flex items-baseline gap-2">
        <Typography
          size="display-sm"
          weight="semibold"
          className="leading-none tracking-display tabular-nums"
        >
          {depositPaidFormatted}
        </Typography>
        <Typography size="sm" color="tertiary" className="pb-0.5 tabular-nums">
          {t('view.buyers.list.summary.outOfPurchasePrice', {amount: purchasePriceFormatted})}
        </Typography>
      </div>
      <Typography size="sm" weight="bold" className="ms-auto">
        {t('view.buyers.list.summary.progressPercent', {percent: Math.round(percent)})}
      </Typography>
    </div>
  );
};
